import { useEffect, useState } from "react";

/**
 * Returns the current timestamp in milliseconds, updated on the given interval.
 *
 * @param intervalMs - How often to update the timestamp. Defaults to 1000ms.
 */
export function useCurrentTime(intervalMs = 1_000): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const intervalId = window.setInterval(
      () => setNowMs(Date.now()),
      intervalMs,
    );
    return () => window.clearInterval(intervalId);
  }, [intervalMs]);

  return nowMs;
}
